import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from '@/lib/firebase'
import { TeacherSettingsProvider } from '@/providers'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <TeacherSettingsProvider>
        <App />
      </TeacherSettingsProvider>
    </AuthProvider>
  </StrictMode>,
)
